import { getBranch } from "../../restaurant/libs/branchAdapter";
import {
  IConsumable,
  IMenu,
  IMenuCategories,
  IMenuList,
  IProduct,
  IProductInfo,
} from "../types/Menu";

export const getMenuProduct = (item?: IProduct) => ({
  _id: item?._id ?? "",
  title: item?.title ?? "",
  description: item?.description ?? "",
  price: item?.price ?? 0,
  image: item?.image ?? "",
  categories: item?.categories ?? [],
  composition: {
    weight: item?.composition?.weight ?? 0,
    calories: item?.composition?.calories ?? 0,
    proteins: item?.composition?.proteins ?? 0,
    fats: item?.composition?.fats ?? 0,
    carbohydrates: item?.composition?.carbohydrates ?? 0,
    ingredients: item?.composition?.ingredients ?? "",
  },
});

export const getCategories = (item?: IMenuCategories) => ({
  _id: item?._id ?? "",
  title: item?.title ?? "",
  image: item?.image ?? "",
  products: item?.products?.map(getMenuProduct) ?? [],
});

export const menuAdapter = (item?: IMenu) => ({
  _id: item?._id ?? "",
  branch: getBranch(item?.branch),
  categories: item?.categories?.map(getCategories) ?? [],
});

// -----------------------------------------------------------------------------

export const getConsumable = (item?: IConsumable): IConsumable => ({
  id: item?.id ?? 0,
  title: item?.title ?? "",
  title_ru: item?.title_ru ?? null,
  title_uz: item?.title_uz ?? null,
  title_en: item?.title_en ?? null,
});

export const getProduct = (item?: IProductInfo) => ({
  category_id: item?.category_id ?? 0,
  category_title: item?.category_title ?? "",
  category_title_uz: item?.category_title_uz ?? "",
  category_title_en: item?.category_title_en ?? "",
  category_img: item?.category_img ? `${item.category_img}` : "",
  id: item?.id ?? 0,
  // Артикул: под ним товары лежат в номенклатуре Mindbox (view-product,
  // set-cart). Без него туда уходил id меню, и Mindbox товар не узнавал.
  sku: item?.sku ?? null,
  title: item?.title ?? "",
  title_uz: item?.title_uz ?? "",
  title_en: item?.title_en ?? "",
  description: item?.description ?? "",
  description_uz: item?.description_uz ?? "",
  description_en: item?.description_en ?? "",
  image: item?.image ?? "",
  org_price: item?.org_price ?? "",
  type: item?.type ?? "",
  org: item?.org ?? 0,
  menu_image: item?.menu_image ?? "",
  additional_image: item?.additional_image ?? null,
  modifier_groups: item?.modifier_groups ?? null,
  author: item?.author ?? null,
  author_name: item?.author_name ?? null,
  border_color: item?.border_color ?? null,
  background_gradient: item?.background_gradient ?? null,
  has_custom_content: item?.has_custom_content ?? false,
  consumables: item?.consumables?.map(getConsumable) ?? null,
  max_cart_qty: item?.max_cart_qty ?? null,
});

export const menuListMapper = (item?: IMenuList) => ({
  id: item?.id ?? 0,
  category: {
    id: item?.category?.id ?? 0,
    title: item?.category?.title ?? "",
    title_uz: item?.category?.title_uz ?? "",
    title_en: item?.category?.title_en ?? "",
    server_time: item?.category?.server_time ?? null,
    promotion_end_date: item?.category?.promotion_end_date ?? null,
  },
  menu: item?.menu?.map(getProduct) ?? [],
});

export const menuListAdapter = (data?: IMenuList[]) =>
  data?.map((item) => menuListMapper(item)) ?? [];
